import React from "react";
import "./appLayout.scss";

// components
// import Navbar from "../../common/navbar/Navbar";
import Footer from "../../common/footer/Footer";
import Navbar2 from "../../common/navbar2/Navbar2";

const AppLayout = ({ children }) => {
  return (
    <div className="appLayout">
      {/* <Navbar /> */}
      <Navbar2 />
      <main id="main" className="appLayout__main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default AppLayout;
